import { yupResolver } from '@hookform/resolvers/yup';
import { useSnackbar } from 'notistack';
import React from 'react';
import { Resolver, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { handleError } from '../../../../shared/functions/handleError';
import { IProject } from '../../../../shared/interfaces/projects/IProject';
import { AdminProjectsService } from '../service';
import { projectSchema } from './ProjectCreate';
import ProjectForm from './ProjectForm';

const ProjectUpdate = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const { id } = useParams();
  const { handleSubmit, control, watch, setValue, getValues } =
    useForm<IProject>({
      resolver: yupResolver(projectSchema) as unknown as Resolver<IProject>,
      defaultValues: async () => {
        try {
          const response = await AdminProjectsService.getSingle(Number(id));
          return {
            ...response,
            clientId: response?.client?.id,
            userIds: response?.users?.map((user) => user?.id),
          } as IProject;
        } catch (error) {
          console.error('Error fetching projects details:', error);
          // Return default values or handle the error appropriately
          return {} as IProject;
        }
      },
    });

  const submitHandler = (formData: IProject) => {
    id &&
      AdminProjectsService.update(formData, +id)
        .then((response) => {
          if (response) {
            navigate(-1);
            enqueueSnackbar(
              t('toasts.successfullyUpdated', { title: formData?.name }),
              {
                variant: 'success',
              },
            );
          }
        })
        .catch(handleError);
  };
  return (
    <form onSubmit={handleSubmit(submitHandler)}>
      <ProjectForm
        control={control}
        watch={watch}
        project={getValues()}
        setValue={setValue}
        isUpdate
      />
    </form>
  );
};

export default ProjectUpdate;
